import { render, staticRenderFns } from "./PageRelatorio.vue?vue&type=template&id=5b0cbc64"
import script from "./PageRelatorio.vue?vue&type=script&lang=js"
export * from "./PageRelatorio.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports